/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_AmendmentInputs */

const en_orders_cancel_amendment = /** @type {(inputs: Orders_Cancel_AmendmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Amendment`)
};

const es_orders_cancel_amendment = /** @type {(inputs: Orders_Cancel_AmendmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar enmienda`)
};

/**
* | output |
* | --- |
* | "Cancel Amendment" |
*
* @param {Orders_Cancel_AmendmentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_amendment = /** @type {((inputs?: Orders_Cancel_AmendmentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_AmendmentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_amendment(inputs)
	return es_orders_cancel_amendment(inputs)
});